import { type ItemContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import classnames from "classnames";
import Component, { type ListsItemComponentProps } from "./component";
import { getIcon } from "./lib";

export type ListsItemContainerProps = ItemContainerProps & {};

const makeMapStateToProps = () => {
  const iconChooserSelector = getSettingValueSelector(TargetSelector.Entity, "iconChooser");
  const parentListIconStyleSelector = getSettingValueSelector(TargetSelector.Entity, "listIconStyle");
  const titleSelector = getSettingValueSelector(TargetSelector.Entity, "title");

  return (state: AppState, props: ItemContainerProps): ListsItemComponentProps => {
    const icon = iconChooserSelector(state, props);
    const style = parentListIconStyleSelector(state, { id: props.parentId, source: props.source });

    return {
      ...props,
      className: classnames("list-icon-item"),
      icon: getIcon(icon, style),
      title: titleSelector(state, props)
    };
  };
};

export default connectCustom<ListsItemComponentProps, null, ListsItemContainerProps>(makeMapStateToProps)(Component);
